<div [loading]="loading">
  <div *ngIf="!loading">
    <h1>Schválení způsobu řešení záboru</h1>

    <!--    Project type ADDITIONAL-->
    <ng-container>
      <fieldset *ngIf="isAdditional">
        <legend>Řešení záboru</legend>
        <div class="flexbox-container">
          <div class="column-33">
            <div class="info-label">Parcela</div>
            <cell-parcel
              [parcel]="occupationObject.parcel"
              [occupation]="occupationObject"
              [cellClass]="''">
            </cell-parcel>
          </div>
          <div class="column-33">
            <div class="info-label">Zábor</div>
            <cell-occupation
              [occupation]="occupationObject"
              [visibleApprove]="false">
            </cell-occupation>
          </div>
          <div class="column-33">
            <div class="info-label">Navrhovaný stav</div>
            <div><strong>{{ occupationObject.finalSolutionType?.name }}</strong></div>
            <ng-container *ngIf="occupationObject.finalSolutionReason">
              <div class="info-label mt-10">Důvod požadavku</div>
              <p style="white-space: pre-wrap">{{ occupationObject.finalSolutionReason }}</p>
            </ng-container>
          </div>
        </div>
      </fieldset>
    </ng-container>

    <!--   Project type INVEST  -->
    <ng-container visibleByBrand="mpv" *ngIf="isInvest">
      <fieldset>
        <legend>Řešení záboru</legend>
        <div class="section-label">Aktuální stav</div>
        <div class="flexbox-container mt-15">
          <div class="column-30">
            <div class="info-label">Parcela</div>
            <cell-parcel
              [parcel]="occupationObject.parcel"
              [occupation]="occupationObject"
              [cellClass]="''">
            </cell-parcel>
          </div>
          <div class="column-20">
            <div class="info-label">Zábor</div>
            <cell-occupation
              [occupation]="occupationObject"
              [visibleApprove]="false"
              [showNabyvatel]="false"
            >
            </cell-occupation>
            <ng-container *ngIf="occupationObject.nabyvatel && occupationObject.finalSolutionOtherChange?.newNabyvatel">
              <div class="info-label mt-10">Nabyvatel</div>
              <div>{{ occupationObject.nabyvatel }}</div>
              <div *ngIf="occupationObject.typNabyvatele">Typ: {{ occupationObject.typNabyvatele }}</div>
              <div *ngIf="occupationObject.icoNabyvatele">IČO: {{ occupationObject.icoNabyvatele }}</div>
            </ng-container>
          </div>
          <div *ngIf="occupationObject.finalSolutionOtherChange && occupationObject.finalSolutionOtherChange.changeConstructionObjects" class="column-50">
            <div class="info-label">Objektová skladba záboru</div>
            <span class="other-change-current-value">
              <div *ngFor="let co of occupationObject.constructionObjects" style="color: inherit">{{ co | constructionObjectName }}</div>
            </span>
          </div>
        </div>

        <hr class="section-divider">

        <div class="section-label">Navrhovaný stav</div>
        <div class="flexbox-container mt-15">
          <div class="column-30">
            <div class="info-label">Typ změny</div>
            <div><strong>{{ occupationObject.finalSolutionType?.name }}</strong></div>
            <ng-container *ngIf="occupationObject.finalSolutionReason">
              <div class="info-label mt-10">Důvod požadavku</div>
              <p style="white-space: pre-wrap">{{ occupationObject.finalSolutionReason }}</p>
            </ng-container>
                <div *ngIf="occupationObject?.finalSolutionOtherChange?.changeGeometry" class="checklist-item">
                  <strong>Změna výměry a geometrie (bez GP)</strong>
                </div>
                <div *ngIf="occupationObject?.finalSolutionOtherChange?.changeWholeParcel" class="checklist-item">
                  <strong>Celá parcela</strong>
                </div>
          </div>
          <div *ngIf="occupationObject.finalSolutionOtherChange"
               class="column-20">
            <div class="info-label">Zábor</div>
            <cell-occupation
              [occupation]="occupationObject"
              [visibleApprove]="false"
              [markedDiff]="true"
              [showNabyvatel]="false">
            </cell-occupation>
            <ng-container *ngIf="occupationObject.finalSolutionOtherChange?.newNabyvatel">
              <div class="info-label mt-10">Nabyvatel</div>
              <div class="occupation-solution-highlight">{{ occupationObject.finalSolutionOtherChange.newNabyvatel.nabyvatel }}</div>
              <div *ngIf="occupationObject.finalSolutionOtherChange.newNabyvatel.typNabyvatele" class="occupation-solution-highlight">Typ: {{ occupationObject.finalSolutionOtherChange.newNabyvatel.typNabyvatele }}</div>
              <div *ngIf="occupationObject.finalSolutionOtherChange.newNabyvatel.icoNabyvatele" class="occupation-solution-highlight">IČO: {{ occupationObject.finalSolutionOtherChange.newNabyvatel.icoNabyvatele }}</div>
            </ng-container>
          </div>
          <div *ngIf="occupationObject.finalSolutionOtherChange && occupationObject.finalSolutionOtherChange.changeConstructionObjects" class="column-50">
            <div class="info-label">Objektová skladba záboru</div>
            <span class="other-change-current-value">
              <div *ngFor="let co of newConstructionObjects" class="occupation-solution-highlight">{{ co.endDate }}{{ co | constructionObjectName }}</div>
            </span>
          </div>
        </div>
      </fieldset>
    </ng-container>
    <span *ngIf="!occupationUpdatePaused && showApproveWarning" class="text-uppercase occupation-solution-warning">
        <i class="error-message fa fa-exclamation-triangle"></i>
        Navrhovaná změna záboru bude po kliknutí na Schválit provedena. Akci nelze vrátit zpět.
      </span>
    <span *ngIf="occupationUpdatePaused" class="text-uppercase occupation-solution-warning">
        <i class="error-message fa fa-exclamation-triangle"></i>
        Aktualizaci dat nelze provést, probíhá aktualizace záborových dat. Důvod: {{ occupationUpdatePausedReason }}
    </span>
    <div *ngIf="errorMessage" class="error-message-container">
      <i class="error-message fa fa-exclamation-circle"></i>
      {{ errorMessage }}
    </div>
    <div [loading]="saving"></div>
    <div class="actions">
      <gmt-button [clickAction]="onApprove" [gmtDisabled]="occupationUpdatePaused || saving">Schválit</gmt-button>
    </div>
    <fieldset>
      <legend>Důvod zamítnutí</legend>
      <div class="column-100">
        <label class="required">Text poznámky</label>
        <textarea [(ngModel)]="occupationObject.finalSolutionNote" rows="5"></textarea>
      </div>
    </fieldset>
    <div class="actions">
      <gmt-button [clickAction]="onReject" [gmtDisabled]="!occupationObject.finalSolutionNote || saving" class="red">Zamítnout</gmt-button>
    </div>
  </div>
</div>
